/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import { FiraSansBold } from 'components/Text/Text';


export const EmailContainer = styled.div`
margin-top: 20px;
border: 1px solid ${Colors.BLUE};
background: #fff;
margin-bottom: 40px;
resize: both;
`

export const EmailHeader = styled.div`
display: flex;
align-items: center;
text-transform: uppercase;
font-weight:bold;
font-size: 14px;
padding:10px;
background-color:${Colors.BLUE};
color:${Colors.WHITE};
`;

export const TitleContainer = styled.div`
display: flex;
width: 55%;
justify-content: space-between;
align-items: center;

`;

export const ModalTitle = styled.div`
position: relative;
overflow-wrap: break-word;
`

export const ContPages = styled.div`
display:flex;
justify-content:space-evenly;
align-items: center;
background-color:transparent;
min-width: 250px;
max-width: 300px;
`;

export const EmailContent = styled.div`
 display:flex;
 flex-direction: column;
 align-items: center;
 position: relative;
 overflow: hidden;
 margin-top: 50px;
`;

export const FieldTitle = styled.p`
font-size: 13px;
font-weight: ${FiraSansBold};margin: 0px;
width: 60px;
color: ${Colors.GRAY[6]};
`

export const EmailFieldRow = styled.div`
display: flex;
width: 99%;
align-items: center;
margin-bottom: 20px;
gap: 40px;
`
